module.exports = __webpack_public_path__ + "static/media/snowball_war.9d21a60a.jpg";